var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "disclaimer", title: "Disclaimer" } },
    [
      _vm._v("\n  The "),
      _c("em", [_vm._v("Company")]),
      _vm._v(" makes only the guarantee in "),
      _c("site-link", { attrs: { to: { hash: "#guarantee" } } }, [
        _vm._v("Guarantee"),
      ]),
      _vm._v(". Otherwise, the "),
      _c("em", [_vm._v("Company")]),
      _vm._v(" provides\n  "),
      _c("em", [_vm._v("Font Awesome Pro")]),
      _vm._v(" entirely as is, without any warranty at all.\n  "),
      _c("span", { staticClass: "text-uppercase" }, [
        _vm._v(
          "\n    The terms set forth herein are exclusive and in lieu of all other express and implied warranties and conditions whatsoever, whether statutory, commonlaw,\n    or otherwise, including but not limited to implied warranties of merchantability, fitness for particular purpose and satisfactory quality. customer\n    expressly waives any rights that it might otherwise have."
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }